import { AuthProvider } from './auth';
import { CartProvider } from './cart';

type AppProviderProps ={
	children: React.ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => (
	<AuthProvider>
		<CartProvider>
			{children}
		</CartProvider>
	</AuthProvider>
);

export default AppProvider;